import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f0342c9&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0342c9')) {
      api.createRecord('6f0342c9', component.options)
    } else {
      api.reload('6f0342c9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f0342c9&", function () {
      api.rerender('6f0342c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/venueBasicManage/index.vue"
export default component.exports